import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as FileClock } from '../../assets/icons/file-clock.svg';
import { ReactComponent as UserHand } from '../../assets/icons/user-hand.svg';
import { ReactComponent as Star } from '../../assets/icons/star.svg';
import { pushInteractionEvent } from '../../services/gtmService';

const DisclaimerLogin = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    pushInteractionEvent('interaction_home', 'Iniciar sesión');
    navigate('/login')
  }

  return (
    <div className='bg-white rounded-3xl p-10 mt-4 flex flex-col gap-2 font-roboto text-blue_text'>
      <div className='text-base font-semibold'>Obtén beneficios iniciando sesión:</div>
      <div className="flex gap-2 items-center">
        <FileClock className='w-[25px]' />
        <div className='text-sm'>Seguimiento de tus ahorros</div>
      </div>
      <div className="flex gap-2 items-center">
        <UserHand />
        <div className='text-sm'>Acceso a todas las promociones</div>
      </div>
      <div className="flex gap-2 items-center">
        <Star />
        <div className='text-sm'>Canjes al instante</div>
      </div>
      <div id='buttonLogin' onClick={handleClick} className='flex justify-center items-center gap-[10px] mt-8 py-5 px-10 bg-[#100E9D] rounded-xl cursor-pointer'>
        <div className='text-white font-semibold'>
          Iniciar sesión
        </div>
      </div>
    </div>
  )
}

export default DisclaimerLogin
